import { ArrowLeftIcon } from "@chakra-ui/icons";
import {
  Box,
  Heading,
  Container,
  Text,
  Button,
  Stack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <>
      <Container maxW={"3xl"}>
        <Stack
          as={Box}
          textAlign={"center"}
          spacing={{ base: 8, md: 14 }}
          py={{ base: 20, md: 36 }}
        >
          <Heading
            fontWeight={600}
            fontSize={{ base: "2xl", sm: "4xl", md: "6xl" }}
            lineHeight={"110%"}
          >
            Page Not Found <br />
            <Text as={"span"} color={"#00bfa6"}>
              404 Error
            </Text>
          </Heading>
          <Text color={"gray.500"}>
            The page you are looking for could not be found.
          </Text>
          <Stack
            direction={"column"}
            spacing={3}
            align={"center"}
            alignSelf={"center"}
            position={"relative"}
          >
            <Button
            leftIcon={<ArrowLeftIcon />}
              onClick={() => {
                navigate("/");
              }}
              colorScheme={"green"}
              bg={"#00bfa6"}
              rounded={"full"}
              px={6}
              _hover={{
                bg: "white",
                color: "#00bfa6",
                border: "1px solid #00bfa6",
              }}
            >
              Back to Home
            </Button>
          </Stack>
        </Stack>
      </Container>
    </>
  );
}
